(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-live-info/assets/javascripts/casino-game-players.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-live-info/assets/javascripts/casino-game-players.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const formatCurrency = svs.utils.format.Currency;
const _svs$components$casin = svs.components.casino_react.common.utils,
  isLiveTableClosed = _svs$components$casin.isLiveTableClosed,
  getSeatsLeft = _svs$components$casin.getSeatsLeft;
const CasinoGamePlayers = _ref => {
  let gameModel = _ref.gameModel,
    liveData = _ref.liveData;
  if (!gameModel || !liveData) {
    return null;
  }
  const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
  if (!useCloudCasinoApis) {
    var _liveData$seatsTaken;
    const closed = isLiveTableClosed(liveData);
    const hasSeats = gameModel.liveCategory === 'blackjack' || (liveData === null || liveData === void 0 || (_liveData$seatsTaken = liveData.seatsTaken) === null || _liveData$seatsTaken === void 0 ? void 0 : _liveData$seatsTaken.length);
    if (hasSeats && closed) {
      return React.createElement("li", null, "Platser:", ' ', React.createElement("span", {
        className: "casino-game-players__item-text"
      }, getSeatsLeft({
        provider: gameModel.provider,
        liveData
      })));
    }
    if (closed) {
      return React.createElement("li", {
        className: "casino-game-players__item"
      }, React.createElement(Icon, {
        color: "fc-white",
        icon: "person",
        size: 100
      }), React.createElement("span", {
        className: "casino-game-players__item-text"
      }, "0"));
    }
    if (!closed && (liveData.players >= 0 || hasSeats)) {
      return React.createElement("li", {
        className: "casino-game-players__item"
      }, React.createElement(Icon, {
        color: "fc-white",
        icon: "person",
        size: 100
      }), React.createElement("span", {
        className: "casino-game-players__item-text"
      }, formatCurrency(liveData.players)));
    }
    return null;
  }
  const hasSeats = gameModel.liveCategory === 'blackjack' || (liveData === null || liveData === void 0 ? void 0 : liveData.seatsTaken);
  if (hasSeats && liveData.tableClosed) {
    return React.createElement("li", null, "Platser:", ' ', React.createElement("span", {
      className: "casino-game-players__item-text"
    }, liveData.seatsLeft));
  }
  if (liveData.tableClosed) {
    return React.createElement("li", {
      className: "casino-game-players__item"
    }, React.createElement(Icon, {
      color: "fc-white",
      icon: "person",
      size: 100
    }), React.createElement("span", {
      className: "casino-game-players__item-text"
    }, "0"));
  }
  if (!liveData.tableClosed && (liveData.players >= 0 || hasSeats)) {
    return React.createElement("li", {
      className: "casino-game-players__item"
    }, React.createElement(Icon, {
      color: "fc-white",
      icon: "person",
      size: 100
    }), React.createElement("span", {
      className: "casino-game-players__item-text"
    }, formatCurrency(liveData.players)));
  }
  return null;
};
setGlobal('svs.components.casino_react.casino_game_live_info.CasinoGamePlayers', CasinoGamePlayers);

 })(window);